module.exports = __webpack_public_path__ + "static/media/membersNew.633810c3.svg";